import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

const CATEGORY_LABEL_MAP = {
  cdn: 'CDN',
  'web-servers': 'Web Server',
  'javascript-libraries': 'Javascript Library',
  'tag-managers': 'Tag Manager',
  analytics: 'Analytics',
};

const getFirstCategory = (categories) => {
  if (!categories) return '';
  if (Array.isArray(categories)) {
    const first = categories[0];
    if (!first) return '';
    // Some APIs return array of strings, legacy returned array of objects with name
    return typeof first === 'string' ? first : (first?.name || '');
  }
  return '';
};

const getCategoryLabel = (category) => {
  if (!category) return '';
  return CATEGORY_LABEL_MAP[category] || category;
};

/**
 * Transforms the technologies criteria from WooRank API response
 * @param {Object} technologiesCriteria - criteria.technologies
 * @returns {Object} - Transformed technologies data for React components
 */
export const transformTechnologies = (technologiesCriteria) => {
  if (!technologiesCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No technologies were detected.',
      data: null,
    };
  }

  const data = technologiesCriteria?.data || {};
  const wooRankStatus = technologiesCriteria?.status || 'neutral';
  const importance = technologiesCriteria?.importance || 0;
  const solvability = technologiesCriteria?.solvability || 0;

  const items = (data?.technologies || [])
    .map((t) => {
      const name = t?.app || '';
      const category = getFirstCategory(t?.categories);
      const categoryLabel = getCategoryLabel(category);
      return { name, category, categoryLabel };
    })
    .filter((t) => Boolean(t.name));

  const isEmpty = items.length === 0;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: isEmpty ? 'No technologies were detected.' : null,
    data: isEmpty ? null : { items },
  };
};

export default transformTechnologies;


